import React from 'react';
import { useTranslation } from 'react-i18next';
import { BannerLayout, BannerMessage } from '@wix/da-ds/pkg/Banner/lego';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';

import { sanitizeHref } from '@wix/da-url';

import s from './GenericErrorBanner.scss';

interface Props {
  learnMoreUrl?: string;
}

const GenericErrorBanner: React.FC<Props> = ({ learnMoreUrl }) => {
  const { t } = useTranslation();
  return (
    <BannerLayout
      size="big"
      className={s['banner']}
      body={[
        <BannerMessage className={s['message']} key="message" weight="reg">
          {t('deviationSubmit.form.errorBanner.message', {
            postProcess: 'reactPostprocessor',
            learnMoreLink: (
              <PlainButtonOrLink className={s['learn-more']} href={sanitizeHref(learnMoreUrl)}>
                {t('deviationSubmit.form.errorBanner.learnMoreText')}
              </PlainButtonOrLink>
            ),
          })}
        </BannerMessage>,
      ]}
    />
  );
};
GenericErrorBanner.displayName = 'GenericErrorBannner';

export default GenericErrorBanner;
